<template>
  <div class="container d-flex py-5 main-container">
    <div class="my-auto w-100 main-area nofound-area text-center">
      <span class="error-logo">
        <!--<img src="./../assets/images/wtiogomark.png" alt="logo" class="img-fluid">-->
         <img src="./../assets/images/wtiogomark_ra.png" alt="logo" height="auto" width="20%" class="img-fluid" >
      </span>
      <span class="error-image"><img src="./../assets/images/errorimage.png" alt="logo"
                                     class="img-fluid"></span>
      <h1>Oops!<br/>It’s a dead end...</h1>
      <p>The page you are looking for<br/>
        might have been moved, renamed,<br/>
        or might never existed.</p>
      <div class="btn-toolbar justify-content-center" role="toolbar"
           aria-label="Toolbar with button groups">
        <router-link :to="{ name: 'login' }" class="btn btn-primary">BACK TO HOME</router-link>
      </div>
    </div><!-- ends main-area -->
  </div>
</template>
<script>
export default {
  name: 'PageNotFound',
};
</script>
